import { REMOVE_USER_DATA, SET_USER_DATA, SET_USER_PERMISSION, SET_USER_PREFERENCE } from '../actionTypes/userManagementActionTypes';

import { IUserManagement } from '../../redux/types/userManagement';
import { UserPermission } from '@app/types/UserPermission';

export const defaultUserPermission: UserPermission = {
  //canViewFileArea: undefined,
  canUploadFiles: false,
  canManageFileTags: false,
  canDeleteFileTags: false,
  canManageFileAssign: false,
  canRecategorizeFiles: false,
  canManageFileStatus: false,
  canCheckInCheckOutInternalFiles: false,
  canPublishUnpublishInternalFiles: false,
  canViewFileHistory: false,
  canDeleteFiles: false,
  canManageFileProperties: false,
  canMarkFilesAsToBeDeleted: false,
  canViewFileSourceLink: false,
  //canCreateFileArea: false, // New attribute
  canViewTemplates: undefined,
  canCreateTemplates: false,
  canManageTemplates: false,
  canManageAutoFiling: undefined, // New attribute
  canViewManualRouting: undefined,
  canManageRetention: false, // New attribute
  canMoveFiles: false, // New attribute
  canRenameFiles: false, // New attribute
  canCopyFiles: false, // New attribute
  canLinkUnlinkFiles: false, // New attribute
  canEmailFiles: false, // New attribute
  canCreateBinders: false,
  canUpdateAllBinders: false,
  canUpdateAssignedBinders: false,
  canViewAllBinders: false,
  canViewAssignedBinders: false,
  canOverrideFileRetention: false,
  canViewVersionHistory: false,
  canRestorePreviousVersions: false,
  canDownloadPreviousVersions: false,
  canCreateVersions: false,
  canCreateDocument: false,
  canManageBulkDocumentConfigurations: undefined,
};

export const initialState: IUserManagement = {
  userDetails: undefined,
  userPermission: defaultUserPermission,
  userPreferences: undefined,
};

export const userManagementReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_USER_DATA:
      return {
        ...state,
        userDetails: action.payload,
      };
    case SET_USER_PERMISSION:
      return {
        ...state,
        userPermission: action.payload,
      };
    case REMOVE_USER_DATA:
      return {
        ...state,
        userDetails: undefined,
      };
    case SET_USER_PREFERENCE:
      return {
        ...state,
        userPreferences: action.payload,
      };
    default:
      return state;
  }
};
